import React from "react";
import PlatformSessionPanel from "./PlatformSessionPanel";

export default function JffSyncPanel() {
  return <PlatformSessionPanel platform="justforfans" />;
}
